import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Inbox, CheckCircle2, Clock, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

function Stat({ label, value, icon: Icon, tint = "sage" }) {
  const bg = { sage: "bg-sage-100 text-sage-700", earth: "bg-earth-100 text-earth-800", beige: "bg-beige text-earth-800", blue: "bg-softblue/30 text-earth-800" }[tint];
  return (
    <div className="bg-white rounded-2xl p-6 border border-earth-100" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${bg}`}>
        <Icon className="w-5 h-5" strokeWidth={1.5} />
      </div>
      <div className="mt-4 text-3xl font-serif text-earth-900">{value}</div>
      <div className="text-sm text-earth-600 mt-1">{label}</div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => setStats(null));
  }, []);

  return (
    <div className="flex flex-col gap-8" data-testid="admin-dashboard">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-sage-600">Overview</div>
          <h1 className="font-serif text-4xl text-earth-900 mt-2 font-light">Dashboard</h1>
        </div>
        <Link
          to="/"
          target="_blank"
          className="inline-flex items-center gap-2 text-sm text-earth-700 hover:text-earth-900"
        >
          <ExternalLink className="w-4 h-4" strokeWidth={1.5} /> Preview website
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Total enquiries" value={stats?.total_enquiries ?? "—"} icon={Inbox} tint="earth" />
        <Stat label="New" value={stats?.new ?? "—"} icon={Clock} tint="sage" />
        <Stat label="Contacted" value={stats?.contacted ?? "—"} icon={Clock} tint="blue" />
        <Stat label="Confirmed" value={stats?.confirmed ?? "—"} icon={CheckCircle2} tint="beige" />
      </div>

      <div className="bg-white rounded-2xl p-6 border border-earth-100">
        <div className="flex items-center justify-between">
          <div className="font-serif text-2xl text-earth-900">Recent enquiries</div>
          <Link to="/admin/bookings" className="text-sm text-earth-700 hover:text-earth-900">View all →</Link>
        </div>
        <div className="mt-4 divide-y divide-earth-100">
          {(stats?.recent || []).length === 0 && (
            <div className="py-8 text-earth-500 text-sm">No enquiries yet.</div>
          )}
          {(stats?.recent || []).map((b) => (
            <div key={b.id} className="py-4 flex items-center justify-between">
              <div>
                <div className="text-earth-900 font-medium">{b.name}</div>
                <div className="text-sm text-earth-600">{b.phone} · {b.message?.slice(0, 60) || "—"}</div>
              </div>
              <span className="text-xs uppercase tracking-[0.18em] text-sage-700 bg-sage-100 px-3 py-1 rounded-full">{b.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
